export default __webpack_public_path__ + "static/cafe_36024-ce83867c039baed5285dcbe105de3dda.png";